"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@babel/core");
function getString(node, code) {
    if (!node.start || !node.end)
        return '';
    return code.substring(node.start, node.end);
}
exports.getString = getString;
function getCamelCase() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.map(function (v, i) { var c = v.replace(/^./, function (a) { return a.toUpperCase(); }); return i > 0 ? c : v; }).join("");
}
exports.getCamelCase = getCamelCase;
function renderJSX(_a) {
    var tagName = _a.tagName, attrs = _a.attrs, childrens = _a.childrens;
    if (childrens.length <= 0) {
        return core_1.types.jsxElement(core_1.types.jsxOpeningElement(tagName, attrs, true), null, [], true);
    }
    return core_1.types.jsxElement(core_1.types.jsxOpeningElement(tagName, attrs), core_1.types.jsxClosingElement(tagName), childrens, false);
}
exports.renderJSX = renderJSX;
//# sourceMappingURL=index.js.map